



















































































































































































































import { defineComponent, ref, onBeforeMount } from '@vue/composition-api'
import { searchOrders } from '@/api/search'
import { IDashboardModel } from '@/api/types'
import { getDashboard, deleteOrder } from '@/api/orders'
import { notifyError, notifySuccess } from '@/utils/error-display'

interface FilterOption {
    property: string
    value: string | number
    checked: boolean
    label: string
}

interface Filter {
    property: string
    value: string | number
}

enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

enum OrderStatus {
    Unassigned = 2,
    Assigned = 3,
    Completed = 12,
    Accepted = 5,
    Open = 5,
    All = -1
}

export default defineComponent({
  name: 'dashboard2',
  setup() {
    const loading = ref(true)
    const tableData = ref(null)
    const dashboardModel = ref<IDashboardModel>(null)

    const perPage = ref<number>(20)
    const perPageOptions = ref([
      {
        value: 15,
        label: 15
      },
      {
        value: 20,
        label: 20
      },
      {
        value: 40,
        label: 40
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    const pageNumber = ref(1)
    const keyword = ref<string>(null)
    const sortDirection = ref<SortDirection>(null)
    const sortBy = ref<string>(null)
    const sortByDirectionOptions = ref([
      {
        value: null,
        label: ''
      },
      {
        value: SortDirection.ASC,
        label: 'Ascending'
      },
      {
        value: SortDirection.DESC,
        label: 'Descending'
      }
    ])
    const sortByOptions = ref([
      {
        value: null,
        label: ''
      },
      {
        value: 'OrderId',
        label: 'Order ID'
      },
      {
        value: 'SubjectCity',
        label: 'Subject City'
      },
      {
        value: 'SubjectState',
        label: 'Subject State'
      },
      {
        value: 'SubjectPostalCode',
        label: 'Subject Postal Code'
      },
      {
        value: 'SubjectCounty',
        label: 'Subject County'
      },
      {
        value: 'ContactFirstName',
        label: 'Contact First Name'
      },
      {
        value: 'ContactLastName',
        label: 'Contact Last Name'
      },
      {
        value: 'ContactPhone',
        label: 'Contact Phone'
      },
      {
        value: 'ContactPhone2',
        label: 'Contact Phone 2'
      },
      {
        value: 'ContactEmail',
        label: 'Contact Email'
      }
    ])

    const totalPages = ref<number>(0)
    const totalItems = ref<number>(0)
    const pageItems = ref<number>(0)
    const orderStatus = ref<OrderStatus>(null)
    const orderStatusOptions = ref([
      {
        value: null,
        label: 'All'
      },
      {
        value: 3,
        label: 'Assigned'
      },
      {
        value: 2,
        label: 'Unassigned'
      },
      {
        value: 12,
        label: 'Completed'
      },
      {
        value: 5,
        label: 'Open/In Process'
      },
      {
        value: 9,
        label: 'Canceled/Deleted'
      }
    ])

    const filterOptions = ref<Array<FilterOption>>([
      {
        property: 'Client.Name',
        label: 'Client Name',
        checked: false,
        value: null
      },
      {
        property: 'OrderTypeNavigation.Description',
        label: 'Order Type',
        checked: false,
        value: null
      },
      {
        property: 'OrderStatusNavigation.Name',
        label: 'Order Status',
        checked: false,
        value: null
      },
      {
        property: 'SubjectCity',
        label: 'Subject City',
        checked: false,
        value: null
      },
      {
        property: 'SubjectState',
        label: 'Subject State',
        checked: false,
        value: null
      },
      {
        property: 'SubjectCounty',
        label: 'Subject County',
        checked: false,
        value: null
      }
    ])
    const filterBy = ref<Filter[]>(null)

    const defaultData = {
      perPage: 20,
      pageNumber: 1,
      filterBy: null,
      sort: null,
      sortBy: null,
      orderStatus: null
    }

    const data = ref({
      perPage,
      pageNumber,
      filterBy,
      sort: sortDirection,
      sortBy,
      orderStatus
    })

    const getDashboardData = async() => {
      const response = await getDashboard()
      dashboardModel.value = response.data.orderCounts
    }

    const fetchData = async(_data) => {
      loading.value = true

      const filters: Filter[] = []
      filterOptions.value.forEach(filterOption => {
        if (filterOption.checked && filterOption.value !== null) {
          filters.push({
            property: filterOption.property,
            value: filterOption.value
          })
        }
      })
      _data.filterBy = filters.length > 0 ? filters : null

      const response = (await searchOrders(_data, keyword.value)).data

      pageNumber.value = response.pageNumber
      totalPages.value = response.totalPages
      perPage.value = parseInt(response.perPage)
      totalItems.value = response.totalItems
      pageItems.value = response.pageItems
      tableData.value = response.items
      loading.value = false
    }

    const updatePage = (page) => {
      data.value.pageNumber = page
      fetchData(data.value)
    }

    const updateOrderStatus = (status) => {
      switch (status) {
        case 'all':
          status = null
          break
        case 'open':
          status = 'Accepted'
          break
      }
      data.value.orderStatus = status
      fetchData(data.value)
    }

    const resetAll = () => {
      filterOptions.value.forEach(f => { f.checked = false; f.value = null })
      data.value = defaultData
      keyword.value = null
      orderStatus.value = null
      fetchData(data.value)
    }

    const getTitle = (type: string) :string => {
      switch (type) {
        case 'all': return 'All Orders'
        case 'assigned': return 'Assigned Orders'
        case 'unassigned': return 'Unassigned Orders'
        case 'completed': return 'Completed Orders'
        case 'open': return 'Open or In Process Orders'
      }
      return ''
    }

    const setSelectedStatus = (key) => {
      if (!orderStatus.value && key === 'all') {
        return 'selected'
      }

      if ((orderStatus.value as unknown as string) === 'Accepted' && key === 'open') {
        return 'selected'
      }
      return orderStatus.value === key ? 'selected' : ''
    }

    const updateFilter = (filter) => {
      if (!filter.checked && filter.value != null) {
        filterBy.value = filterBy.value.filter(fil => fil.property !== filter.property)
        fetchData(data.value)
        return
      }

      if (filter.checked && filter.value != null) {
        fetchData(data.value)
      }
    }

    const dialogDeleteOrder = ref(false)
    const deleteReason = ref<string>(null)
    const deleteOrderId = ref(0)
    const deleteTitle = ref<string>(null)

    const handleDelete = async() => {
      dialogDeleteOrder.value = false
      const result = await deleteOrder(deleteOrderId.value, deleteReason.value)
      if (result.startsWith('Success')) {
        notifySuccess(result)
      } else {
        notifyError(result)
      }
      resetAll()
    }

    const showDeleteDialog = async(orderId: number) => {
      closeDeleteDialog()
      deleteReason.value = ''
      deleteOrderId.value = orderId
      deleteTitle.value = 'Cancel/Deactivate Order ' + deleteOrderId.value
    }

    const closeDeleteDialog = () => {
      dialogDeleteOrder.value = false
    }

    onBeforeMount(() => {
      getDashboardData()
      fetchData(data.value)
    })

    return {
      data,
      loading,
      tableData,
      keyword,
      totalPages,
      fetchData,
      updatePage,
      filterBy,
      filterOptions,
      totalItems,
      pageItems,
      perPage,
      perPageOptions,
      dashboardModel,
      orderStatus,
      orderStatusOptions,
      resetAll,
      updateOrderStatus,
      getTitle,
      setSelectedStatus,
      dialogDeleteOrder,
      deleteReason,
      deleteOrderId,
      deleteTitle,
      showDeleteDialog,
      closeDeleteDialog,
      sortBy,
      sortByDirectionOptions,
      sortDirection,
      sortByOptions,
      updateFilter,
      handleDelete
    }
  }
})
